import React from 'react';
import { FormField } from '../../../components/FormField';
import { FormRow } from '../../../components/FormRow';
import { views } from '../../../constants/propertyOptions';
import { formatArea } from '../../../../../../utils/formatters';

interface LandOptionsProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const landTypes = [
  'Constructible',
  'Non constructible',
  'Agricole',
  'Viabilisé',
  'Non viabilisé',
];

const landShapes = [
  'Carré',
  'Rectangulaire',
  'Triangulaire',
  'Irrégulier',
];

const accessTypes = [
  'Route goudronnée',
  'Chemin de terre',
  'Sentier',
  'Accès piéton',
];

const reliefTypes = [
  'Terrain plat',
  'Terrain en pente',
];

export const LandOptions: React.FC<LandOptionsProps> = ({
  formData,
  handleInputChange,
}) => {
  // Gestionnaire pour les champs de surface (supprime les décimales)
  const handleAreaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    // Supprimer tout sauf les chiffres
    const numericValue = value.replace(/[^\d]/g, '');
    
    handleInputChange({
      target: {
        name,
        value: numericValue,
        type: 'text'
      }
    } as React.ChangeEvent<HTMLInputElement>);
  };
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white">
        Caractéristiques du terrain
      </h3>

      <FormRow>
        <FormField label="Type de terrain">
          <select
            name="landType"
            value={formData.landType || ''}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            {landTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </FormField>

        <FormField label="Surface du terrain (m²)">
          <input
            type="text"
            name="landArea"
            value={formatArea(formData.landArea)}
            onChange={handleAreaChange}
            placeholder="0"
          />
        </FormField>
      </FormRow>

      <FormRow>
        <FormField label="Longueur de la façade (m)">
          <input
            type="text"
            name="facadeLength"
            value={formatArea(formData.facadeLength)}
            onChange={handleAreaChange}
            placeholder="0"
          />
        </FormField>

        <FormField label="Forme du terrain">
          <select
            name="landShape"
            value={formData.landShape || ''}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            {landShapes.map(shape => (
              <option key={shape} value={shape}>{shape}</option>
            ))}
          </select>
        </FormField>
      </FormRow>

      <FormField label="Proximité des commodités">
        <div className="grid grid-cols-2 gap-4">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="hasShopsNearby"
              checked={formData.hasShopsNearby || false}
              onChange={handleInputChange}
            />
            <span>Commerces</span>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="hasSchoolsNearby"
              checked={formData.hasSchoolsNearby || false}
              onChange={handleInputChange}
            />
            <span>Écoles</span>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="hasPublicTransportNearby"
              checked={formData.hasPublicTransportNearby || false}
              onChange={handleInputChange}
            />
            <span>Transports publics</span>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="hasHospitalNearby"
              checked={formData.hasHospitalNearby || false}
              onChange={handleInputChange}
            />
            <span>Hôpital</span>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="hasAdministrationNearby"
              checked={formData.hasAdministrationNearby || false}
              onChange={handleInputChange}
            />
            <span>Services administratifs</span>
          </label>
        </div>
      </FormField>

      <FormRow>
        <FormField label="Vue">
          <select
            name="view"
            value={formData.view || ''}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            {views.map(view => (
              <option key={view} value={view}>{view}</option>
            ))}
          </select>
        </FormField>

        <FormField label="Accessibilité">
          <select
            name="accessibility"
            value={formData.accessibility || ''}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            {accessTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </FormField>
      </FormRow>

      <FormField label="Relief">
        <select
          name="relief"
          value={formData.relief || ''}
          onChange={handleInputChange}
          className="w-full"
        >
          <option value="">Sélectionner</option>
          {reliefTypes.map(type => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>
      </FormField>
    </div>
  );
};